module.exports = __webpack_public_path__ + "img/eyebrow_male_arched_thick_mask.1e35be45.png";